import React from "react";

export default function RecipesPages() {
    return (
        <>
            Recipes
        </>
    );
}